import React, {FC} from 'react'
import {SortableTh} from 'jbc-front/components/SearchForm'
import {useHasBranchOffice} from 'hooks/useHasBranchOffice'
import {displayFormat, fullNameFormat} from 'libs/formatter'

interface Employee {
  id: string
  staffCode?: string
  displayFirstName: string
  displayLastName: string
  email?: string
  personnelHistory?: {
    officeName?: string
    employmentTypeName?: string
    group0Name?: string
    group1Name?: string
    group2Name?: string
  }
  currentOffice?: {
    name: string
  }
}

interface EmployeesListProps {
  employees: Employee[]
  currentSortType?: string
  onClickItem: (employeeId: string) => void
  onChangeSortType?: (sortType: string) => void
}

export const EmployeesList: FC<EmployeesListProps> = ({employees, currentSortType, onClickItem, onChangeSortType}) => {
  const hasBranchOffice = useHasBranchOffice()

  return (
    <div className="l-overflow-scroll">
      <table className="m-table-list m-table-fixed">
        <thead>
          <tr>
            <SortableTh
              field="staff_code"
              globalClassName="m-table-list-staffcode"
              currentSortType={currentSortType}
              onChange={onChangeSortType}
            >
              スタッフ
              <wbr />
              コード
            </SortableTh>
            <SortableTh field="full_name_kana" currentSortType={currentSortType} onChange={onChangeSortType}>
              氏名
            </SortableTh>
            <th>メールアドレス</th>
            <SortableTh field="employment_type" currentSortType={currentSortType} onChange={onChangeSortType}>
              雇用形態
            </SortableTh>
            {hasBranchOffice && (
              <SortableTh field="office" currentSortType={currentSortType} onChange={onChangeSortType}>
                適用事業所
              </SortableTh>
            )}
            <SortableTh field="group" currentSortType={currentSortType} onChange={onChangeSortType}>
              グループ
            </SortableTh>
          </tr>
        </thead>
        <tbody>
          {employees.map((employee) => {
            const groups = [
              employee.personnelHistory?.group0Name,
              employee.personnelHistory?.group1Name,
              employee.personnelHistory?.group2Name,
            ].filter((v) => v)

            return (
              <tr
                key={employee.id}
                style={{cursor: 'pointer'}}
                className="table-hover"
                onClick={() => onClickItem(employee.id)}
              >
                <td>{displayFormat(employee.staffCode)}</td>
                <td>{fullNameFormat(employee.displayLastName, employee.displayFirstName)}</td>
                <td>{displayFormat(employee.email)}</td>
                <td>{displayFormat(employee.personnelHistory?.employmentTypeName)}</td>
                {hasBranchOffice && (
                  <td>{displayFormat(employee.personnelHistory?.officeName || employee.currentOffice?.name)}</td>
                )}
                <td>
                  {groups.length
                    ? groups.map((group, index) => (
                        <span key={index}>
                          {group}
                          <br />
                        </span>
                      ))
                    : displayFormat()}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
